import { render, staticRenderFns } from "./TrackingRuleNotificationsUpsert.vue?vue&type=template&id=2561ec12&scoped=true&"
import script from "./TrackingRuleNotificationsUpsert.vue?vue&type=script&lang=js&"
export * from "./TrackingRuleNotificationsUpsert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2561ec12",
  null
  
)

export default component.exports